import React, { useEffect } from 'react';
import { auth } from '../../firebase-config';
import { useAuth } from '../../contexts/AuthContext';

function FirebaseAuthListener({ children }) {
  const { setCurrentUser, setAuthInitialized } = useAuth();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
      setAuthInitialized(true);
    });

    return unsubscribe;
  }, [setCurrentUser, setAuthInitialized]);

  return <>{children}</>;
}

export default FirebaseAuthListener; 